import Stack from "@mui/material/Stack";
import { Link, useLocation } from "react-router";
import TextField from "@mui/material/TextField";
import React from "react";
import Button from "@mui/material/Button";
import { FormProvider, useForm } from "react-hook-form";
import InputAdornment from "@mui/material/InputAdornment";
import SelectInput from "../../../../components/Inputs/SelectInput";
import InputLabel from "@mui/material/InputLabel";
import FormHelperText from "@mui/material/FormHelperText";
import ButtonSelectCover from "../../../../components/Button/ButtonSelectCover";
import PaperDialog from "../../../../components/Dialog/PaperDialog";
import LoadingDataAlert from "../../../../components/Alert/LoadingDataAlert";
import SuccessSubmitDataAlert from "../../../../components/Alert/SuccessSubmitDataAlert";
import ErrorSubmitDataAlert from "../../../../components/Alert/ErrorSubmitDataAlert";
import { useData } from "../../../../lib/context/DataContext";

const categories = ["Boeuf", "Veau", "Agneau", "Porc", "Volaille", "Abats"];
const unites = ["Kg", "Pièce"];

export default function GestionModifierProduit() {
	const methods = useForm();
	const { produits } = useData();
	const idProduit = useLocation().pathname.split("/")[4];
	const [status, setStatus] = React.useState("loading");

	React.useEffect(() => {
		if (produits.loading === false && status !== "success") {
			const produit = produits.data.find(
				(item) => item.rowKey === idProduit
			);

			methods.setValue("name", produit.name);
			methods.setValue("categorie", produit.categorie);
			methods.setValue("unite", produit.unite);
			methods.setValue("prix", produit.prix);

			setStatus(null);
		}
	}, [produits, idProduit, methods, status]);

	const onSubmit = async (data) => {
		setStatus("loading");

		if (data.cover) {
			try {
				const file = data.cover[0];
				const fileName = data.name.replaceAll(/\W/g, "") + ".png";
				const contentType = file.type;

				// Étape 1 — Demander une URL SAS depuis l'API Azure Function
				const res = await fetch("/api/uploadCoverProduit", {
					method: "POST",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify({ fileName, contentType }),
				});

				if (!res.ok)
					throw new Error(
						"Erreur lors de la récupération de l’URL SAS"
					);

				const { sasUrl } = await res.json();

				// Étape 2 — PUT du fichier directement dans Azure Blob Storage
				const putRes = await fetch(sasUrl, {
					method: "PUT",
					headers: {
						"x-ms-blob-type": "BlockBlob",
						"Content-Type": contentType,
					},
					body: file,
				});

				methods.setValue("isCover", true);

				if (!putRes.ok)
					throw new Error("Erreur lors de l’envoi sur le blob");

				console.log("✅ Upload réussi !");
			} catch (err) {
				console.error("Erreur upload:", err);
			}
		}

		const updateProduit = {
			partitionKey: idProduit,
			rowKey: idProduit,
			categorie: data.categorie,
			name: data.name,
			unite: data.unite,
			prix: parseFloat(data.prix.replaceAll(",", ".")).toFixed(2),
			cover: data.cover ? true : false,
		};

		try {
			const res = await fetch("/api/updateProduit", {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(updateProduit),
			});

			if (res.ok) {
				setStatus("success");
			} else {
				setStatus("error");
			}
		} catch (err) {
			setStatus("error");
		} finally {
			await produits.fetchDataProduits();
		}
	};

	return (
		<FormProvider {...methods}>
			<PaperDialog
				titre="Modifier un produit"
				onSubmit={methods.handleSubmit(onSubmit)}
				actions={
					!status ? (
						<Button
							variant="contained"
							color="success"
							fullWidth
							type="submit"
						>
							Envoyer
						</Button>
					) : (
						<Link to="..">
							<Button
								color="error"
								size="small"
								variant="contained"
							>
								Fermer
							</Button>
						</Link>
					)
				}
			>
				{status === "error" && (
					<ErrorSubmitDataAlert>
						la modification du produit
					</ErrorSubmitDataAlert>
				)}
				{status === "loading" && <LoadingDataAlert />}
				{status === "success" && (
					<SuccessSubmitDataAlert>
						Le produit a été modifier avec succèss !
					</SuccessSubmitDataAlert>
				)}
				{!status && (
					<Stack spacing={1}>
						<TextField
							variant="standard"
							label="Nom"
							required
							helperText="Indiquer le nom du produit"
							{...methods.register("name")}
						/>
						<SelectInput
							name="Catégorie"
							formValue="categorie"
							helperText="Sélectionner la categorie du produit"
							selectList={categories}
						/>
						<SelectInput
							name="Unité"
							formValue="unite"
							helperText="Sélectionner l'unité de vente"
							selectList={unites}
						/>
						<TextField
							label="Prix"
							variant="standard"
							required
							helperText="Indiquer le prix du produit"
							{...methods.register("prix")}
							slotProps={{
								input: {
									startAdornment: (
										<InputAdornment position="start">
											€/Kg
										</InputAdornment>
									),
									inputMode: "decimal", // Clavier numérique sur mobile
									type: "text", // Accepte , ou .
									pattern: "[0-9]+([,.][0-9]{1,2})?", // Optionnel pour limiter la saisie
								},
							}}
						/>
						<InputLabel>Illustration</InputLabel>
						<ButtonSelectCover />
						<FormHelperText>
							Cliquer sur le bouton pour sélectionner une
							illustration sur votre ordinateur. format carré
							préconisé.
						</FormHelperText>
					</Stack>
				)}
			</PaperDialog>
		</FormProvider>
	);
}
